import { useNavigate } from 'react-router-dom';
import { useModal } from '../../../helpers/hooks/modalContext';
import { openIdentityVerificationModal } from '../../../helpers/utils/login';
import { openDashboardPayRentFlow } from '../../../helpers/utils/payFlowGuard';
import { useAuth } from '../../../auth/Auth';
import { buildingDetails } from '../../../helpers/utils/types';

interface props {
  buildingData: buildingDetails[] | null;
  variant?: 'auth-hold' | 'default';
}

const IDVMessage = ({ buildingData, variant = 'default' }: props) => {
  const navigate = useNavigate();
  const { modalState, setModal } = useModal();
  const { auth, currentUser } = useAuth();

  const tenantBuildingId = buildingData?.[0]?.building?.tenantBuildingId ?? '';
  const hasBuilding = Boolean(tenantBuildingId);

  const isAuthHold = variant === 'auth-hold';

  const handleVerifyNow = () => {
    // No building yet — same newsetup path as Pay Now when the tenant has no property.
    if (!hasBuilding) {
      void openDashboardPayRentFlow(
        buildingData,
        setModal,
        navigate,
        auth?.data.token,
        modalState
      );
      return;
    }

    openIdentityVerificationModal(setModal, auth?.data.token || '', tenantBuildingId, {
      pendingIdvAuthHold: isAuthHold,
      userId: currentUser?.user?.userId,
    });
  };

  return (
    <div className='verify-strip'>
      <div className='verify-strip-glow' aria-hidden='true' />
      <div className='vi-icon' aria-hidden='true'>
        <svg
          width='20'
          height='20'
          viewBox='0 0 24 24'
          fill='none'
          stroke='var(--color-blue)'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <rect x='3' y='11' width='18' height='11' rx='2' />
          <path d='M7 11V7a5 5 0 0110 0v4' />
        </svg>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
          <div className='vi-title'>
            {isAuthHold ? 'Complete identity verification' : 'Verify your identity'}
          </div>
          <span className='vi-step-badge'>2 min · 1 step</span>
        </div>
        <div className='vi-sub'>
          {isAuthHold ? (
            <>
              Hold active. This is a temporary auth hold, not a charge. Complete IDV to capture the
              payment, otherwise your rent to the landlord will be delayed.
            </>
          ) : (
            <>
              Unlock credit reporting, rent payments, and more. One-time setup. Takes just a few
              minutes.
            </>
          )}
        </div>
      </div>
      <button type='button' className='btn-blue' onClick={handleVerifyNow}>
        {isAuthHold ? 'Start IDV now' : 'Verify now'}
      </button>
    </div>
  );
};

export default IDVMessage;
